var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0078 27.5C8.10425 27.5 2.50781 21.9035 2.50781 15C2.50781 8.09644 8.10425 2.5 15.0078 2.5C21.9113 2.5 27.5078 8.09644 27.5078 15C27.5078 21.9035 21.9113 27.5 15.0078 27.5ZM15.0078 25C20.5307 25 25.0078 20.5229 25.0078 15C25.0078 9.47715 20.5307 5 15.0078 5C9.48496 5 5.00781 9.47715 5.00781 15C5.00781 20.5229 9.48496 25 15.0078 25ZM16.2578 13.125V18.75H17.5078V21.25H12.5078V18.75H13.7578V15.625H12.5078V13.125H16.2578ZM16.8828 10C16.8828 11.0355 16.0433 11.875 15.0078 11.875C13.9723 11.875 13.1328 11.0355 13.1328 10C13.1328 8.96446 13.9723 8.125 15.0078 8.125C16.0433 8.125 16.8828 8.96446 16.8828 10Z",
    fill: "#516CD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientInfo);
export default __webpack_public_path__ + "static/media/PatientInfo.522fdd8a2138a69095569609c8d6f6d9.svg";
export { ForwardRef as ReactComponent };